import { useEffect } from 'react';
import { isEmpty } from 'lodash/lang';
import { get, has } from 'lodash/object';

import { setIn } from '../../../../services/immutable';
import { useEuiFiltersDispatch, useEuiFiltersState } from '../EuiFiltersContext';
import { FRS_LOADED, FRS_READY } from '../reducer';

export default function useFilterSyncCache({ uniqKey, checkVersion = true, disabled = false }) {
  const state = useEuiFiltersState();
  const dispatch = useEuiFiltersDispatch();

  const status = get(state, ['schema', uniqKey, 'status']);

  useEffect(
    function() {
      if (disabled) return;
      if (status !== FRS_LOADED) return;

      dispatch({
        type: 'PERFORM',
        processor: syncCacheProcessor,
        payload: { uniqKey, checkVersion }
      });
    },
    [dispatch, status, uniqKey, checkVersion, disabled]
  );
}

function syncCacheProcessor(state, action) {
  const { payload } = action;
  const { uniqKey, checkVersion } = payload;
  const skip = checkVersion && state.version !== state.cache.version;
  const fCache = get(state, ['cache', uniqKey]);

  let nextState = state;
  if (has(state, uniqKey)) {
    if (!isEmpty(fCache) && !skip) {
      nextState[uniqKey] = {
        ...nextState[uniqKey],
        ...fCache
      };
    }
    nextState = setIn(nextState, ['schema', uniqKey, 'status'], FRS_READY);
  }
  return nextState;
}
